import styled from '@emotion/styled';

import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { theme } from '../../theme/theme';

export function IndicatorString({ device, capabilityId }) {
  const [value] = useCapabilityValue({ deviceId: device.id, capabilityId });

  return <IndicatorString.Root>{value}</IndicatorString.Root>;
}

IndicatorString.Root = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  font-size: ${theme.fontSize.tiny};
  font-weight: ${theme.fontWeight.bold};
  -webkit-line-clamp: 3;
  line-clamp: 3;
  max-width: 54px;
  word-break: break-word;
  overflow: hidden;
`;
